const joursFeries = [
  {
    "date": "1950-01-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Jour de l'an"
  },
  {
    "date": "1950-04-10",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pâques"
  },
  {
    "date": "1950-05-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête du travail"
  },
  {
    "date": "1950-05-08",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Victoire des alliés"
  },
  {
    "date": "1950-05-18",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Ascension"
  },
  {
    "date": "1950-05-29",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pentecôte"
  },
  {
    "date": "1950-07-14",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête Nationale"
  },
  {
    "date": "1950-08-15",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Assomption"
  },
  {
    "date": "1950-11-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Toussaint"
  },
  {
    "date": "1950-11-11",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Armistice"
  },
  {
    "date": "1950-12-25",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Noël"
  },
  {
    "date": "1951-01-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Jour de l'an"
  },
  {
    "date": "1951-03-26",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pâques"
  },
  {
    "date": "1951-05-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête du travail"
  },
  {
    "date": "1951-05-03",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Ascension"
  },
  {
    "date": "1951-05-08",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Victoire des alliés"
  },
  {
    "date": "1951-05-14",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pentecôte"
  },
  {
    "date": "1951-07-14",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête Nationale"
  },
  {
    "date": "1951-08-15",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Assomption"
  },
  {
    "date": "1951-11-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Toussaint"
  },
  {
    "date": "1951-11-11",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Armistice"
  },
  {
    "date": "1951-12-25",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Noël"
  },
  {
    "date": "1952-01-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Jour de l'an"
  },
  {
    "date": "1952-04-14",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pâques"
  },
  {
    "date": "1952-05-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête du travail"
  },
  {
    "date": "1952-05-08",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Victoire des alliés"
  },
  {
    "date": "1952-05-22",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Ascension"
  },
  {
    "date": "1952-06-02",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pentecôte"
  },
  {
    "date": "1952-07-14",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête Nationale"
  },
  {
    "date": "1952-08-15",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Assomption"
  },
  {
    "date": "1952-11-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Toussaint"
  },
  {
    "date": "1952-11-11",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Armistice"
  },
  {
    "date": "1952-12-25",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Noël"
  },
  {
    "date": "1953-01-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Jour de l'an"
  },
  {
    "date": "1953-04-06",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pâques"
  },
  {
    "date": "1953-05-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête du travail"
  },
  {
    "date": "1953-05-08",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Victoire des alliés"
  },
  {
    "date": "1953-05-14",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Ascension"
  },
  {
    "date": "1953-05-25",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pentecôte"
  },
  {
    "date": "1953-07-14",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête Nationale"
  },
  {
    "date": "1953-08-15",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Assomption"
  },
  {
    "date": "1953-11-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Toussaint"
  },
  {
    "date": "1953-11-11",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Armistice"
  },
  {
    "date": "1953-12-25",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Noël"
  },
  {
    "date": "1954-01-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Jour de l'an"
  },
  {
    "date": "1954-05-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête du travail"
  },
  {
    "date": "1954-05-02",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pâques"
  },
  {
    "date": "1954-05-08",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Victoire des alliés"
  },
  {
    "date": "1954-06-09",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Ascension"
  },
  {
    "date": "1954-06-20",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pentecôte"
  },
  {
    "date": "1954-07-14",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête Nationale"
  },
  {
    "date": "1954-08-15",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Assomption"
  },
  {
    "date": "1954-11-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Toussaint"
  },
  {
    "date": "1954-11-11",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Armistice"
  },
  {
    "date": "1954-12-25",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Noël"
  },
  {
    "date": "1955-01-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Jour de l'an"
  },
  {
    "date": "1955-04-11",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pâques"
  },
  {
    "date": "1955-05-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête du travail"
  },
  {
    "date": "1955-05-08",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Victoire des alliés"
  },
  {
    "date": "1955-05-19",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Ascension"
  },
  {
    "date": "1955-05-30",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pentecôte"
  },
  {
    "date": "1955-07-14",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête Nationale"
  },
  {
    "date": "1955-08-15",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Assomption"
  },
  {
    "date": "1955-11-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Toussaint"
  },
  {
    "date": "1955-11-11",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Armistice"
  },
  {
    "date": "1955-12-25",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Noël"
  },
  {
    "date": "1956-01-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Jour de l'an"
  },
  {
    "date": "1956-04-02",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pâques"
  },
  {
    "date": "1956-05-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête du travail"
  },
  {
    "date": "1956-05-08",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Victoire des alliés"
  },
  {
    "date": "1956-05-10",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Ascension"
  },
  {
    "date": "1956-05-21",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pentecôte"
  },
  {
    "date": "1956-07-14",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête Nationale"
  },
  {
    "date": "1956-08-15",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Assomption"
  },
  {
    "date": "1956-11-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Toussaint"
  },
  {
    "date": "1956-11-11",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Armistice"
  },
  {
    "date": "1956-12-25",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Noël"
  },
  {
    "date": "1957-01-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Jour de l'an"
  },
  {
    "date": "1957-04-22",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pâques"
  },
  {
    "date": "1957-05-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête du travail"
  },
  {
    "date": "1957-05-08",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Victoire des alliés"
  },
  {
    "date": "1957-05-30",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Ascension"
  },
  {
    "date": "1957-06-10",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pentecôte"
  },
  {
    "date": "1957-07-14",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête Nationale"
  },
  {
    "date": "1957-08-15",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Assomption"
  },
  {
    "date": "1957-11-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Toussaint"
  },
  {
    "date": "1957-11-11",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Armistice"
  },
  {
    "date": "1957-12-25",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Noël"
  },
  {
    "date": "1958-01-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Jour de l'an"
  },
  {
    "date": "1958-04-07",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pâques"
  },
  {
    "date": "1958-05-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête du travail"
  },
  {
    "date": "1958-05-08",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Victoire des alliés"
  },
  {
    "date": "1958-05-15",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Ascension"
  },
  {
    "date": "1958-05-26",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pentecôte"
  },
  {
    "date": "1958-07-14",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête Nationale"
  },
  {
    "date": "1958-08-15",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Assomption"
  },
  {
    "date": "1958-11-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Toussaint"
  },
  {
    "date": "1958-11-11",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Armistice"
  },
  {
    "date": "1958-12-25",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Noël"
  },
  {
    "date": "1959-01-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Jour de l'an"
  },
  {
    "date": "1959-03-30",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pâques"
  },
  {
    "date": "1959-05-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête du travail"
  },
  {
    "date": "1959-05-07",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Ascension"
  },
  {
    "date": "1959-05-08",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Victoire des alliés"
  },
  {
    "date": "1959-05-18",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pentecôte"
  },
  {
    "date": "1959-07-14",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête Nationale"
  },
  {
    "date": "1959-08-15",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Assomption"
  },
  {
    "date": "1959-11-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Toussaint"
  },
  {
    "date": "1959-11-11",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Armistice"
  },
  {
    "date": "1959-12-25",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Noël"
  },
  {
    "date": "1960-01-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Jour de l'an"
  },
  {
    "date": "1960-04-18",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pâques"
  },
  {
    "date": "1960-05-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête du travail"
  },
  {
    "date": "1960-05-08",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Victoire des alliés"
  },
  {
    "date": "1960-05-26",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Ascension"
  },
  {
    "date": "1960-06-06",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pentecôte"
  },
  {
    "date": "1960-07-14",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête Nationale"
  },
  {
    "date": "1960-08-15",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Assomption"
  },
  {
    "date": "1960-11-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Toussaint"
  },
  {
    "date": "1960-11-11",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Armistice"
  },
  {
    "date": "1960-12-25",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Noël"
  },
  {
    "date": "1961-01-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Jour de l'an"
  },
  {
    "date": "1961-04-03",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pâques"
  },
  {
    "date": "1961-05-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête du travail"
  },
  {
    "date": "1961-05-08",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Victoire des alliés"
  },
  {
    "date": "1961-05-11",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Ascension"
  },
  {
    "date": "1961-05-22",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pentecôte"
  },
  {
    "date": "1961-07-14",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête Nationale"
  },
  {
    "date": "1961-08-15",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Assomption"
  },
  {
    "date": "1961-11-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Toussaint"
  },
  {
    "date": "1961-11-11",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Armistice"
  },
  {
    "date": "1961-12-25",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Noël"
  },
  {
    "date": "1962-01-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Jour de l'an"
  },
  {
    "date": "1962-04-23",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pâques"
  },
  {
    "date": "1962-05-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête du travail"
  },
  {
    "date": "1962-05-08",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Victoire des alliés"
  },
  {
    "date": "1962-05-31",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Ascension"
  },
  {
    "date": "1962-06-11",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pentecôte"
  },
  {
    "date": "1962-07-14",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête Nationale"
  },
  {
    "date": "1962-08-15",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Assomption"
  },
  {
    "date": "1962-11-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Toussaint"
  },
  {
    "date": "1962-11-11",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Armistice"
  },
  {
    "date": "1962-12-25",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Noël"
  },
  {
    "date": "1963-01-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Jour de l'an"
  },
  {
    "date": "1963-04-15",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pâques"
  },
  {
    "date": "1963-05-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête du travail"
  },
  {
    "date": "1963-05-08",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Victoire des alliés"
  },
  {
    "date": "1963-05-23",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Ascension"
  },
  {
    "date": "1963-06-03",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pentecôte"
  },
  {
    "date": "1963-07-14",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête Nationale"
  },
  {
    "date": "1963-08-15",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Assomption"
  },
  {
    "date": "1963-11-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Toussaint"
  },
  {
    "date": "1963-11-11",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Armistice"
  },
  {
    "date": "1963-12-25",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Noël"
  },
  {
    "date": "1964-01-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Jour de l'an"
  },
  {
    "date": "1964-03-30",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pâques"
  },
  {
    "date": "1964-05-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête du travail"
  },
  {
    "date": "1964-05-07",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Ascension"
  },
  {
    "date": "1964-05-08",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Victoire des alliés"
  },
  {
    "date": "1964-05-18",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pentecôte"
  },
  {
    "date": "1964-07-14",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête Nationale"
  },
  {
    "date": "1964-08-15",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Assomption"
  },
  {
    "date": "1964-11-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Toussaint"
  },
  {
    "date": "1964-11-11",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Armistice"
  },
  {
    "date": "1964-12-25",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Noël"
  },
  {
    "date": "1965-01-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Jour de l'an"
  },
  {
    "date": "1965-04-19",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pâques"
  },
  {
    "date": "1965-05-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête du travail"
  },
  {
    "date": "1965-05-08",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Victoire des alliés"
  },
  {
    "date": "1965-05-27",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Ascension"
  },
  {
    "date": "1965-06-07",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pentecôte"
  },
  {
    "date": "1965-07-14",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête Nationale"
  },
  {
    "date": "1965-08-15",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Assomption"
  },
  {
    "date": "1965-11-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Toussaint"
  },
  {
    "date": "1965-11-11",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Armistice"
  },
  {
    "date": "1965-12-25",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Noël"
  },
  {
    "date": "1966-01-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Jour de l'an"
  },
  {
    "date": "1966-04-11",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pâques"
  },
  {
    "date": "1966-05-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête du travail"
  },
  {
    "date": "1966-05-08",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Victoire des alliés"
  },
  {
    "date": "1966-05-19",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Ascension"
  },
  {
    "date": "1966-05-30",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pentecôte"
  },
  {
    "date": "1966-07-14",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête Nationale"
  },
  {
    "date": "1966-08-15",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Assomption"
  },
  {
    "date": "1966-11-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Toussaint"
  },
  {
    "date": "1966-11-11",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Armistice"
  },
  {
    "date": "1966-12-25",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Noël"
  },
  {
    "date": "1967-01-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Jour de l'an"
  },
  {
    "date": "1967-03-27",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pâques"
  },
  {
    "date": "1967-05-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête du travail"
  },
  {
    "date": "1967-05-04",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Ascension"
  },
  {
    "date": "1967-05-08",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Victoire des alliés"
  },
  {
    "date": "1967-05-15",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pentecôte"
  },
  {
    "date": "1967-07-14",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête Nationale"
  },
  {
    "date": "1967-08-15",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Assomption"
  },
  {
    "date": "1967-11-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Toussaint"
  },
  {
    "date": "1967-11-11",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Armistice"
  },
  {
    "date": "1967-12-25",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Noël"
  },
  {
    "date": "1968-01-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Jour de l'an"
  },
  {
    "date": "1968-04-15",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pâques"
  },
  {
    "date": "1968-05-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête du travail"
  },
  {
    "date": "1968-05-08",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Victoire des alliés"
  },
  {
    "date": "1968-05-23",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Ascension"
  },
  {
    "date": "1968-06-03",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pentecôte"
  },
  {
    "date": "1968-07-14",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête Nationale"
  },
  {
    "date": "1968-08-15",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Assomption"
  },
  {
    "date": "1968-11-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Toussaint"
  },
  {
    "date": "1968-11-11",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Armistice"
  },
  {
    "date": "1968-12-25",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Noël"
  },
  {
    "date": "1969-01-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Jour de l'an"
  },
  {
    "date": "1969-04-07",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pâques"
  },
  {
    "date": "1969-05-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête du travail"
  },
  {
    "date": "1969-05-08",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Victoire des alliés"
  },
  {
    "date": "1969-05-15",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Ascension"
  },
  {
    "date": "1969-05-26",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pentecôte"
  },
  {
    "date": "1969-07-14",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête Nationale"
  },
  {
    "date": "1969-08-15",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Assomption"
  },
  {
    "date": "1969-11-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Toussaint"
  },
  {
    "date": "1969-11-11",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Armistice"
  },
  {
    "date": "1969-12-25",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Noël"
  },
  {
    "date": "1970-01-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Jour de l'an"
  },
  {
    "date": "1970-03-30",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pâques"
  },
  {
    "date": "1970-05-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête du travail"
  },
  {
    "date": "1970-05-07",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Ascension"
  },
  {
    "date": "1970-05-08",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Victoire des alliés"
  },
  {
    "date": "1970-05-18",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pentecôte"
  },
  {
    "date": "1970-07-14",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête Nationale"
  },
  {
    "date": "1970-08-15",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Assomption"
  },
  {
    "date": "1970-11-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Toussaint"
  },
  {
    "date": "1970-11-11",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Armistice"
  },
  {
    "date": "1970-12-25",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Noël"
  },
  {
    "date": "1971-01-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Jour de l'an"
  },
  {
    "date": "1971-04-12",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pâques"
  },
  {
    "date": "1971-05-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête du travail"
  },
  {
    "date": "1971-05-08",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Victoire des alliés"
  },
  {
    "date": "1971-05-20",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Ascension"
  },
  {
    "date": "1971-05-31",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pentecôte"
  },
  {
    "date": "1971-07-14",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête Nationale"
  },
  {
    "date": "1971-08-15",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Assomption"
  },
  {
    "date": "1971-11-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Toussaint"
  },
  {
    "date": "1971-11-11",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Armistice"
  },
  {
    "date": "1971-12-25",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Noël"
  },
  {
    "date": "1972-01-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Jour de l'an"
  },
  {
    "date": "1972-04-03",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pâques"
  },
  {
    "date": "1972-05-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête du travail"
  },
  {
    "date": "1972-05-08",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Victoire des alliés"
  },
  {
    "date": "1972-05-11",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Ascension"
  },
  {
    "date": "1972-05-22",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pentecôte"
  },
  {
    "date": "1972-07-14",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête Nationale"
  },
  {
    "date": "1972-08-15",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Assomption"
  },
  {
    "date": "1972-11-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Toussaint"
  },
  {
    "date": "1972-11-11",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Armistice"
  },
  {
    "date": "1972-12-25",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Noël"
  },
  {
    "date": "1973-01-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Jour de l'an"
  },
  {
    "date": "1973-04-23",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pâques"
  },
  {
    "date": "1973-05-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête du travail"
  },
  {
    "date": "1973-05-08",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Victoire des alliés"
  },
  {
    "date": "1973-05-31",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Ascension"
  },
  {
    "date": "1973-06-11",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pentecôte"
  },
  {
    "date": "1973-07-14",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête Nationale"
  },
  {
    "date": "1973-08-15",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Assomption"
  },
  {
    "date": "1973-11-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Toussaint"
  },
  {
    "date": "1973-11-11",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Armistice"
  },
  {
    "date": "1973-12-25",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Noël"
  },
  {
    "date": "1974-01-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Jour de l'an"
  },
  {
    "date": "1974-04-15",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pâques"
  },
  {
    "date": "1974-05-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête du travail"
  },
  {
    "date": "1974-05-08",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Victoire des alliés"
  },
  {
    "date": "1974-05-23",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Ascension"
  },
  {
    "date": "1974-06-03",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pentecôte"
  },
  {
    "date": "1974-07-14",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête Nationale"
  },
  {
    "date": "1974-08-15",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Assomption"
  },
  {
    "date": "1974-11-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Toussaint"
  },
  {
    "date": "1974-11-11",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Armistice"
  },
  {
    "date": "1974-12-25",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Noël"
  },
  {
    "date": "1975-01-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Jour de l'an"
  },
  {
    "date": "1975-03-31",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pâques"
  },
  {
    "date": "1975-05-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête du travail"
  },
  {
    "date": "1975-05-08",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Victoire des alliés"
  },
  {
    "date": "1975-05-19",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pentecôte"
  },
  {
    "date": "1975-07-14",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête Nationale"
  },
  {
    "date": "1975-08-15",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Assomption"
  },
  {
    "date": "1975-11-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Toussaint"
  },
  {
    "date": "1975-11-11",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Armistice"
  },
  {
    "date": "1975-12-25",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Noël"
  },
  {
    "date": "1976-01-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Jour de l'an"
  },
  {
    "date": "1976-04-19",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pâques"
  },
  {
    "date": "1976-05-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête du travail"
  },
  {
    "date": "1976-05-08",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Victoire des alliés"
  },
  {
    "date": "1976-05-27",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Ascension"
  },
  {
    "date": "1976-06-07",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pentecôte"
  },
  {
    "date": "1976-07-14",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête Nationale"
  },
  {
    "date": "1976-08-15",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Assomption"
  },
  {
    "date": "1976-11-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Toussaint"
  },
  {
    "date": "1976-11-11",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Armistice"
  },
  {
    "date": "1976-12-25",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Noël"
  },
  {
    "date": "1977-01-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Jour de l'an"
  },
  {
    "date": "1977-04-11",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pâques"
  },
  {
    "date": "1977-05-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête du travail"
  },
  {
    "date": "1977-05-08",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Victoire des alliés"
  },
  {
    "date": "1977-05-19",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Ascension"
  },
  {
    "date": "1977-05-30",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pentecôte"
  },
  {
    "date": "1977-07-14",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête Nationale"
  },
  {
    "date": "1977-08-15",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Assomption"
  },
  {
    "date": "1977-11-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Toussaint"
  },
  {
    "date": "1977-11-11",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Armistice"
  },
  {
    "date": "1977-12-25",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Noël"
  },
  {
    "date": "1978-01-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Jour de l'an"
  },
  {
    "date": "1978-03-27",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pâques"
  },
  {
    "date": "1978-05-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête du travail"
  },
  {
    "date": "1978-05-04",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Ascension"
  },
  {
    "date": "1978-05-08",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Victoire des alliés"
  },
  {
    "date": "1978-05-15",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pentecôte"
  },
  {
    "date": "1978-07-14",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête Nationale"
  },
  {
    "date": "1978-08-15",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Assomption"
  },
  {
    "date": "1978-11-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Toussaint"
  },
  {
    "date": "1978-11-11",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Armistice"
  },
  {
    "date": "1978-12-25",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Noël"
  },
  {
    "date": "1979-01-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Jour de l'an"
  },
  {
    "date": "1979-04-16",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pâques"
  },
  {
    "date": "1979-05-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête du travail"
  },
  {
    "date": "1979-05-08",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Victoire des alliés"
  },
  {
    "date": "1979-05-24",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Ascension"
  },
  {
    "date": "1979-06-04",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pentecôte"
  },
  {
    "date": "1979-07-14",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête Nationale"
  },
  {
    "date": "1979-08-15",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Assomption"
  },
  {
    "date": "1979-11-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Toussaint"
  },
  {
    "date": "1979-11-11",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Armistice"
  },
  {
    "date": "1979-12-25",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Noël"
  },
  {
    "date": "1980-01-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Jour de l'an"
  },
  {
    "date": "1980-04-07",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pâques"
  },
  {
    "date": "1980-05-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête du travail"
  },
  {
    "date": "1980-05-08",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Victoire des alliés"
  },
  {
    "date": "1980-05-15",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Ascension"
  },
  {
    "date": "1980-05-26",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pentecôte"
  },
  {
    "date": "1980-07-14",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête Nationale"
  },
  {
    "date": "1980-08-15",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Assomption"
  },
  {
    "date": "1980-11-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Toussaint"
  },
  {
    "date": "1980-11-11",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Armistice"
  },
  {
    "date": "1980-12-25",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Noël"
  },
  {
    "date": "1981-01-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Jour de l'an"
  },
  {
    "date": "1981-05-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête du travail"
  },
  {
    "date": "1981-05-03",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pâques"
  },
  {
    "date": "1981-05-08",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Victoire des alliés"
  },
  {
    "date": "1981-06-10",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Ascension"
  },
  {
    "date": "1981-06-21",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pentecôte"
  },
  {
    "date": "1981-07-14",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête Nationale"
  },
  {
    "date": "1981-08-15",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Assomption"
  },
  {
    "date": "1981-11-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Toussaint"
  },
  {
    "date": "1981-11-11",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Armistice"
  },
  {
    "date": "1981-12-25",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Noël"
  },
  {
    "date": "1982-01-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Jour de l'an"
  },
  {
    "date": "1982-04-12",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pâques"
  },
  {
    "date": "1982-05-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête du travail"
  },
  {
    "date": "1982-05-08",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Victoire des alliés"
  },
  {
    "date": "1982-05-20",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Ascension"
  },
  {
    "date": "1982-05-31",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pentecôte"
  },
  {
    "date": "1982-07-14",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête Nationale"
  },
  {
    "date": "1982-08-15",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Assomption"
  },
  {
    "date": "1982-11-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Toussaint"
  },
  {
    "date": "1982-11-11",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Armistice"
  },
  {
    "date": "1982-12-25",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Noël"
  },
  {
    "date": "1983-01-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Jour de l'an"
  },
  {
    "date": "1983-04-04",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pâques"
  },
  {
    "date": "1983-05-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête du travail"
  },
  {
    "date": "1983-05-08",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Victoire des alliés"
  },
  {
    "date": "1983-05-12",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Ascension"
  },
  {
    "date": "1983-05-23",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pentecôte"
  },
  {
    "date": "1983-07-14",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête Nationale"
  },
  {
    "date": "1983-08-15",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Assomption"
  },
  {
    "date": "1983-11-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Toussaint"
  },
  {
    "date": "1983-11-11",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Armistice"
  },
  {
    "date": "1983-12-25",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Noël"
  },
  {
    "date": "1984-01-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Jour de l'an"
  },
  {
    "date": "1984-04-23",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pâques"
  },
  {
    "date": "1984-05-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête du travail"
  },
  {
    "date": "1984-05-08",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Victoire des alliés"
  },
  {
    "date": "1984-05-31",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Ascension"
  },
  {
    "date": "1984-06-11",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pentecôte"
  },
  {
    "date": "1984-07-14",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête Nationale"
  },
  {
    "date": "1984-08-15",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Assomption"
  },
  {
    "date": "1984-11-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Toussaint"
  },
  {
    "date": "1984-11-11",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Armistice"
  },
  {
    "date": "1984-12-25",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Noël"
  },
  {
    "date": "1985-01-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Jour de l'an"
  },
  {
    "date": "1985-04-08",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pâques"
  },
  {
    "date": "1985-05-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête du travail"
  },
  {
    "date": "1985-05-08",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Victoire des alliés"
  },
  {
    "date": "1985-05-16",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Ascension"
  },
  {
    "date": "1985-05-27",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pentecôte"
  },
  {
    "date": "1985-07-14",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête Nationale"
  },
  {
    "date": "1985-08-15",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Assomption"
  },
  {
    "date": "1985-11-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Toussaint"
  },
  {
    "date": "1985-11-11",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Armistice"
  },
  {
    "date": "1985-12-25",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Noël"
  },
  {
    "date": "1986-01-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Jour de l'an"
  },
  {
    "date": "1986-03-31",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pâques"
  },
  {
    "date": "1986-05-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête du travail"
  },
  {
    "date": "1986-05-08",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Victoire des alliés"
  },
  {
    "date": "1986-05-19",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pentecôte"
  },
  {
    "date": "1986-07-14",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête Nationale"
  },
  {
    "date": "1986-08-15",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Assomption"
  },
  {
    "date": "1986-11-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Toussaint"
  },
  {
    "date": "1986-11-11",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Armistice"
  },
  {
    "date": "1986-12-25",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Noël"
  },
  {
    "date": "1987-01-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Jour de l'an"
  },
  {
    "date": "1987-04-20",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pâques"
  },
  {
    "date": "1987-05-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête du travail"
  },
  {
    "date": "1987-05-08",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Victoire des alliés"
  },
  {
    "date": "1987-05-28",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Ascension"
  },
  {
    "date": "1987-06-08",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pentecôte"
  },
  {
    "date": "1987-07-14",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête Nationale"
  },
  {
    "date": "1987-08-15",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Assomption"
  },
  {
    "date": "1987-11-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Toussaint"
  },
  {
    "date": "1987-11-11",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Armistice"
  },
  {
    "date": "1987-12-25",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Noël"
  },
  {
    "date": "1988-01-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Jour de l'an"
  },
  {
    "date": "1988-04-04",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pâques"
  },
  {
    "date": "1988-05-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête du travail"
  },
  {
    "date": "1988-05-08",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Victoire des alliés"
  },
  {
    "date": "1988-05-12",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Ascension"
  },
  {
    "date": "1988-05-23",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pentecôte"
  },
  {
    "date": "1988-07-14",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête Nationale"
  },
  {
    "date": "1988-08-15",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Assomption"
  },
  {
    "date": "1988-11-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Toussaint"
  },
  {
    "date": "1988-11-11",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Armistice"
  },
  {
    "date": "1988-12-25",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Noël"
  },
  {
    "date": "1989-01-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Jour de l'an"
  },
  {
    "date": "1989-03-27",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pâques"
  },
  {
    "date": "1989-05-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête du travail"
  },
  {
    "date": "1989-05-04",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Ascension"
  },
  {
    "date": "1989-05-08",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Victoire des alliés"
  },
  {
    "date": "1989-05-15",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pentecôte"
  },
  {
    "date": "1989-07-14",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête Nationale"
  },
  {
    "date": "1989-08-15",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Assomption"
  },
  {
    "date": "1989-11-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Toussaint"
  },
  {
    "date": "1989-11-11",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Armistice"
  },
  {
    "date": "1989-12-25",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Noël"
  },
  {
    "date": "1990-01-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Jour de l'an"
  },
  {
    "date": "1990-04-16",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pâques"
  },
  {
    "date": "1990-05-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête du travail"
  },
  {
    "date": "1990-05-08",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Victoire des alliés"
  },
  {
    "date": "1990-05-24",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Ascension"
  },
  {
    "date": "1990-06-04",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pentecôte"
  },
  {
    "date": "1990-07-14",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête Nationale"
  },
  {
    "date": "1990-08-15",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Assomption"
  },
  {
    "date": "1990-11-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Toussaint"
  },
  {
    "date": "1990-11-11",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Armistice"
  },
  {
    "date": "1990-12-25",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Noël"
  },
  {
    "date": "1991-01-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Jour de l'an"
  },
  {
    "date": "1991-04-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pâques"
  },
  {
    "date": "1991-05-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête du travail"
  },
  {
    "date": "1991-05-08",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Victoire des alliés"
  },
  {
    "date": "1991-05-09",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Ascension"
  },
  {
    "date": "1991-05-20",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pentecôte"
  },
  {
    "date": "1991-07-14",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête Nationale"
  },
  {
    "date": "1991-08-15",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Assomption"
  },
  {
    "date": "1991-11-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Toussaint"
  },
  {
    "date": "1991-11-11",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Armistice"
  },
  {
    "date": "1991-12-25",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Noël"
  },
  {
    "date": "1992-01-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Jour de l'an"
  },
  {
    "date": "1992-04-20",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pâques"
  },
  {
    "date": "1992-05-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête du travail"
  },
  {
    "date": "1992-05-08",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Victoire des alliés"
  },
  {
    "date": "1992-05-28",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Ascension"
  },
  {
    "date": "1992-06-08",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pentecôte"
  },
  {
    "date": "1992-07-14",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête Nationale"
  },
  {
    "date": "1992-08-15",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Assomption"
  },
  {
    "date": "1992-11-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Toussaint"
  },
  {
    "date": "1992-11-11",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Armistice"
  },
  {
    "date": "1992-12-25",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Noël"
  },
  {
    "date": "1993-01-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Jour de l'an"
  },
  {
    "date": "1993-04-12",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pâques"
  },
  {
    "date": "1993-05-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête du travail"
  },
  {
    "date": "1993-05-08",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Victoire des alliés"
  },
  {
    "date": "1993-05-20",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Ascension"
  },
  {
    "date": "1993-05-31",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pentecôte"
  },
  {
    "date": "1993-07-14",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête Nationale"
  },
  {
    "date": "1993-08-15",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Assomption"
  },
  {
    "date": "1993-11-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Toussaint"
  },
  {
    "date": "1993-11-11",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Armistice"
  },
  {
    "date": "1993-12-25",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Noël"
  },
  {
    "date": "1994-01-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Jour de l'an"
  },
  {
    "date": "1994-04-04",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pâques"
  },
  {
    "date": "1994-05-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête du travail"
  },
  {
    "date": "1994-05-08",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Victoire des alliés"
  },
  {
    "date": "1994-05-12",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Ascension"
  },
  {
    "date": "1994-05-23",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pentecôte"
  },
  {
    "date": "1994-07-14",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête Nationale"
  },
  {
    "date": "1994-08-15",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Assomption"
  },
  {
    "date": "1994-11-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Toussaint"
  },
  {
    "date": "1994-11-11",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Armistice"
  },
  {
    "date": "1994-12-25",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Noël"
  },
  {
    "date": "1995-01-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Jour de l'an"
  },
  {
    "date": "1995-04-17",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pâques"
  },
  {
    "date": "1995-05-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête du travail"
  },
  {
    "date": "1995-05-08",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Victoire des alliés"
  },
  {
    "date": "1995-05-25",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Ascension"
  },
  {
    "date": "1995-06-05",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pentecôte"
  },
  {
    "date": "1995-07-14",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête Nationale"
  },
  {
    "date": "1995-08-15",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Assomption"
  },
  {
    "date": "1995-11-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Toussaint"
  },
  {
    "date": "1995-11-11",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Armistice"
  },
  {
    "date": "1995-12-25",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Noël"
  },
  {
    "date": "1996-01-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Jour de l'an"
  },
  {
    "date": "1996-04-08",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pâques"
  },
  {
    "date": "1996-05-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête du travail"
  },
  {
    "date": "1996-05-08",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Victoire des alliés"
  },
  {
    "date": "1996-05-16",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Ascension"
  },
  {
    "date": "1996-05-27",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pentecôte"
  },
  {
    "date": "1996-07-14",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête Nationale"
  },
  {
    "date": "1996-08-15",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Assomption"
  },
  {
    "date": "1996-11-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Toussaint"
  },
  {
    "date": "1996-11-11",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Armistice"
  },
  {
    "date": "1996-12-25",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Noël"
  },
  {
    "date": "1997-01-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Jour de l'an"
  },
  {
    "date": "1997-03-31",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pâques"
  },
  {
    "date": "1997-05-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête du travail"
  },
  {
    "date": "1997-05-08",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Victoire des alliés"
  },
  {
    "date": "1997-05-19",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pentecôte"
  },
  {
    "date": "1997-07-14",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête Nationale"
  },
  {
    "date": "1997-08-15",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Assomption"
  },
  {
    "date": "1997-11-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Toussaint"
  },
  {
    "date": "1997-11-11",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Armistice"
  },
  {
    "date": "1997-12-25",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Noël"
  },
  {
    "date": "1998-01-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Jour de l'an"
  },
  {
    "date": "1998-04-13",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pâques"
  },
  {
    "date": "1998-05-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête du travail"
  },
  {
    "date": "1998-05-08",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Victoire des alliés"
  },
  {
    "date": "1998-05-21",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Ascension"
  },
  {
    "date": "1998-06-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pentecôte"
  },
  {
    "date": "1998-07-14",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête Nationale"
  },
  {
    "date": "1998-08-15",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Assomption"
  },
  {
    "date": "1998-11-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Toussaint"
  },
  {
    "date": "1998-11-11",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Armistice"
  },
  {
    "date": "1998-12-25",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Noël"
  },
  {
    "date": "1999-01-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Jour de l'an"
  },
  {
    "date": "1999-04-05",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pâques"
  },
  {
    "date": "1999-05-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête du travail"
  },
  {
    "date": "1999-05-08",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Victoire des alliés"
  },
  {
    "date": "1999-05-13",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Ascension"
  },
  {
    "date": "1999-05-24",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pentecôte"
  },
  {
    "date": "1999-07-14",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête Nationale"
  },
  {
    "date": "1999-08-15",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Assomption"
  },
  {
    "date": "1999-11-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Toussaint"
  },
  {
    "date": "1999-11-11",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Armistice"
  },
  {
    "date": "1999-12-25",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Noël"
  },
  {
    "date": "2000-01-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Jour de l'an"
  },
  {
    "date": "2000-04-24",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pâques"
  },
  {
    "date": "2000-05-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête du travail"
  },
  {
    "date": "2000-05-08",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Victoire des alliés"
  },
  {
    "date": "2000-06-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Ascension"
  },
  {
    "date": "2000-06-12",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pentecôte"
  },
  {
    "date": "2000-07-14",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête Nationale"
  },
  {
    "date": "2000-08-15",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Assomption"
  },
  {
    "date": "2000-11-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Toussaint"
  },
  {
    "date": "2000-11-11",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Armistice"
  },
  {
    "date": "2000-12-25",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Noël"
  },
  {
    "date": "2001-01-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Jour de l'an"
  },
  {
    "date": "2001-04-16",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pâques"
  },
  {
    "date": "2001-05-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête du travail"
  },
  {
    "date": "2001-05-08",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Victoire des alliés"
  },
  {
    "date": "2001-05-24",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Ascension"
  },
  {
    "date": "2001-06-04",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pentecôte"
  },
  {
    "date": "2001-07-14",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête Nationale"
  },
  {
    "date": "2001-08-15",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Assomption"
  },
  {
    "date": "2001-11-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Toussaint"
  },
  {
    "date": "2001-11-11",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Armistice"
  },
  {
    "date": "2001-12-25",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Noël"
  },
  {
    "date": "2002-01-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Jour de l'an"
  },
  {
    "date": "2002-04-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pâques"
  },
  {
    "date": "2002-05-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête du travail"
  },
  {
    "date": "2002-05-08",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Victoire des alliés"
  },
  {
    "date": "2002-05-09",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Ascension"
  },
  {
    "date": "2002-05-20",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pentecôte"
  },
  {
    "date": "2002-07-14",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête Nationale"
  },
  {
    "date": "2002-08-15",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Assomption"
  },
  {
    "date": "2002-11-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Toussaint"
  },
  {
    "date": "2002-11-11",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Armistice"
  },
  {
    "date": "2002-12-25",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Noël"
  },
  {
    "date": "2003-01-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Jour de l'an"
  },
  {
    "date": "2003-04-21",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pâques"
  },
  {
    "date": "2003-05-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête du travail"
  },
  {
    "date": "2003-05-08",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Victoire des alliés"
  },
  {
    "date": "2003-05-29",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Ascension"
  },
  {
    "date": "2003-06-09",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pentecôte"
  },
  {
    "date": "2003-07-14",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête Nationale"
  },
  {
    "date": "2003-08-15",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Assomption"
  },
  {
    "date": "2003-11-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Toussaint"
  },
  {
    "date": "2003-11-11",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Armistice"
  },
  {
    "date": "2003-12-25",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Noël"
  },
  {
    "date": "2004-01-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Jour de l'an"
  },
  {
    "date": "2004-04-12",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pâques"
  },
  {
    "date": "2004-05-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête du travail"
  },
  {
    "date": "2004-05-08",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Victoire des alliés"
  },
  {
    "date": "2004-05-20",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Ascension"
  },
  {
    "date": "2004-05-31",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pentecôte"
  },
  {
    "date": "2004-07-14",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête Nationale"
  },
  {
    "date": "2004-08-15",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Assomption"
  },
  {
    "date": "2004-11-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Toussaint"
  },
  {
    "date": "2004-11-11",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Armistice"
  },
  {
    "date": "2004-12-25",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Noël"
  },
  {
    "date": "2005-01-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Jour de l'an"
  },
  {
    "date": "2005-03-28",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pâques"
  },
  {
    "date": "2005-05-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête du travail"
  },
  {
    "date": "2005-05-05",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Ascension"
  },
  {
    "date": "2005-05-08",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Victoire des alliés"
  },
  {
    "date": "2005-05-16",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pentecôte"
  },
  {
    "date": "2005-07-14",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête Nationale"
  },
  {
    "date": "2005-08-15",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Assomption"
  },
  {
    "date": "2005-11-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Toussaint"
  },
  {
    "date": "2005-11-11",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Armistice"
  },
  {
    "date": "2005-12-25",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Noël"
  },
  {
    "date": "2006-01-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Jour de l'an"
  },
  {
    "date": "2006-04-17",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pâques"
  },
  {
    "date": "2006-05-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête du travail"
  },
  {
    "date": "2006-05-08",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Victoire des alliés"
  },
  {
    "date": "2006-05-25",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Ascension"
  },
  {
    "date": "2006-06-05",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pentecôte"
  },
  {
    "date": "2006-07-14",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête Nationale"
  },
  {
    "date": "2006-08-15",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Assomption"
  },
  {
    "date": "2006-11-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Toussaint"
  },
  {
    "date": "2006-11-11",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Armistice"
  },
  {
    "date": "2006-12-25",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Noël"
  },
  {
    "date": "2007-01-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Jour de l'an"
  },
  {
    "date": "2007-04-09",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pâques"
  },
  {
    "date": "2007-05-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête du travail"
  },
  {
    "date": "2007-05-08",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Victoire des alliés"
  },
  {
    "date": "2007-05-17",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Ascension"
  },
  {
    "date": "2007-05-28",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pentecôte"
  },
  {
    "date": "2007-07-14",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête Nationale"
  },
  {
    "date": "2007-08-15",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Assomption"
  },
  {
    "date": "2007-11-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Toussaint"
  },
  {
    "date": "2007-11-11",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Armistice"
  },
  {
    "date": "2007-12-25",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Noël"
  },
  {
    "date": "2008-01-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Jour de l'an"
  },
  {
    "date": "2008-03-24",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pâques"
  },
  {
    "date": "2008-05-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête du travail"
  },
  {
    "date": "2008-05-08",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Victoire des alliés"
  },
  {
    "date": "2008-05-12",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pentecôte"
  },
  {
    "date": "2008-07-14",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête Nationale"
  },
  {
    "date": "2008-08-15",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Assomption"
  },
  {
    "date": "2008-11-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Toussaint"
  },
  {
    "date": "2008-11-11",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Armistice"
  },
  {
    "date": "2008-12-25",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Noël"
  },
  {
    "date": "2009-01-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Jour de l'an"
  },
  {
    "date": "2009-04-13",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pâques"
  },
  {
    "date": "2009-05-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête du travail"
  },
  {
    "date": "2009-05-08",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Victoire des alliés"
  },
  {
    "date": "2009-05-21",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Ascension"
  },
  {
    "date": "2009-06-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pentecôte"
  },
  {
    "date": "2009-07-14",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête Nationale"
  },
  {
    "date": "2009-08-15",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Assomption"
  },
  {
    "date": "2009-11-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Toussaint"
  },
  {
    "date": "2009-11-11",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Armistice"
  },
  {
    "date": "2009-12-25",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Noël"
  },
  {
    "date": "2010-01-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Jour de l'an"
  },
  {
    "date": "2010-04-05",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pâques"
  },
  {
    "date": "2010-05-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête du travail"
  },
  {
    "date": "2010-05-08",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Victoire des alliés"
  },
  {
    "date": "2010-05-13",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Ascension"
  },
  {
    "date": "2010-05-24",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pentecôte"
  },
  {
    "date": "2010-07-14",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête Nationale"
  },
  {
    "date": "2010-08-15",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Assomption"
  },
  {
    "date": "2010-11-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Toussaint"
  },
  {
    "date": "2010-11-11",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Armistice"
  },
  {
    "date": "2010-12-25",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Noël"
  },
  {
    "date": "2011-01-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Jour de l'an"
  },
  {
    "date": "2011-04-25",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pâques"
  },
  {
    "date": "2011-05-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête du travail"
  },
  {
    "date": "2011-05-08",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Victoire des alliés"
  },
  {
    "date": "2011-06-02",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Ascension"
  },
  {
    "date": "2011-06-13",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pentecôte"
  },
  {
    "date": "2011-07-14",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête Nationale"
  },
  {
    "date": "2011-08-15",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Assomption"
  },
  {
    "date": "2011-11-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Toussaint"
  },
  {
    "date": "2011-11-11",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Armistice"
  },
  {
    "date": "2011-12-25",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Noël"
  },
  {
    "date": "2012-01-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Jour de l'an"
  },
  {
    "date": "2012-04-09",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pâques"
  },
  {
    "date": "2012-05-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête du travail"
  },
  {
    "date": "2012-05-08",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Victoire des alliés"
  },
  {
    "date": "2012-05-17",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Ascension"
  },
  {
    "date": "2012-05-28",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pentecôte"
  },
  {
    "date": "2012-07-14",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête Nationale"
  },
  {
    "date": "2012-08-15",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Assomption"
  },
  {
    "date": "2012-11-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Toussaint"
  },
  {
    "date": "2012-11-11",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Armistice"
  },
  {
    "date": "2012-12-25",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Noël"
  },
  {
    "date": "2013-01-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Jour de l'an"
  },
  {
    "date": "2013-04-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pâques"
  },
  {
    "date": "2013-05-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête du travail"
  },
  {
    "date": "2013-05-08",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Victoire des alliés"
  },
  {
    "date": "2013-05-09",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Ascension"
  },
  {
    "date": "2013-05-20",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pentecôte"
  },
  {
    "date": "2013-07-14",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête Nationale"
  },
  {
    "date": "2013-08-15",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Assomption"
  },
  {
    "date": "2013-11-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Toussaint"
  },
  {
    "date": "2013-11-11",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Armistice"
  },
  {
    "date": "2013-12-25",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Noël"
  },
  {
    "date": "2014-01-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Jour de l'an"
  },
  {
    "date": "2014-04-21",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pâques"
  },
  {
    "date": "2014-05-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête du travail"
  },
  {
    "date": "2014-05-08",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Victoire des alliés"
  },
  {
    "date": "2014-05-29",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Ascension"
  },
  {
    "date": "2014-06-09",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pentecôte"
  },
  {
    "date": "2014-07-14",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête Nationale"
  },
  {
    "date": "2014-08-15",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Assomption"
  },
  {
    "date": "2014-11-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Toussaint"
  },
  {
    "date": "2014-11-11",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Armistice"
  },
  {
    "date": "2014-12-25",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Noël"
  },
  {
    "date": "2015-01-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Jour de l'an"
  },
  {
    "date": "2015-04-06",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pâques"
  },
  {
    "date": "2015-05-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête du travail"
  },
  {
    "date": "2015-05-08",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Victoire des alliés"
  },
  {
    "date": "2015-05-14",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Ascension"
  },
  {
    "date": "2015-05-25",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pentecôte"
  },
  {
    "date": "2015-07-14",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête Nationale"
  },
  {
    "date": "2015-08-15",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Assomption"
  },
  {
    "date": "2015-11-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Toussaint"
  },
  {
    "date": "2015-11-11",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Armistice"
  },
  {
    "date": "2015-12-25",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Noël"
  },
  {
    "date": "2016-01-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Jour de l'an"
  },
  {
    "date": "2016-03-28",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pâques"
  },
  {
    "date": "2016-05-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête du travail"
  },
  {
    "date": "2016-05-05",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Ascension"
  },
  {
    "date": "2016-05-08",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Victoire des alliés"
  },
  {
    "date": "2016-05-16",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pentecôte"
  },
  {
    "date": "2016-07-14",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête Nationale"
  },
  {
    "date": "2016-08-15",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Assomption"
  },
  {
    "date": "2016-11-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Toussaint"
  },
  {
    "date": "2016-11-11",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Armistice"
  },
  {
    "date": "2016-12-25",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Noël"
  },
  {
    "date": "2017-01-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Jour de l'an"
  },
  {
    "date": "2017-04-17",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pâques"
  },
  {
    "date": "2017-05-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête du travail"
  },
  {
    "date": "2017-05-08",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Victoire des alliés"
  },
  {
    "date": "2017-05-25",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Ascension"
  },
  {
    "date": "2017-06-05",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pentecôte"
  },
  {
    "date": "2017-07-14",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête Nationale"
  },
  {
    "date": "2017-08-15",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Assomption"
  },
  {
    "date": "2017-11-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Toussaint"
  },
  {
    "date": "2017-11-11",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Armistice"
  },
  {
    "date": "2017-12-25",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Noël"
  },
  {
    "date": "2018-01-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Jour de l'an"
  },
  {
    "date": "2018-04-02",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pâques"
  },
  {
    "date": "2018-05-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête du travail"
  },
  {
    "date": "2018-05-08",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Victoire des alliés"
  },
  {
    "date": "2018-05-10",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Ascension"
  },
  {
    "date": "2018-05-21",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pentecôte"
  },
  {
    "date": "2018-07-14",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête Nationale"
  },
  {
    "date": "2018-08-15",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Assomption"
  },
  {
    "date": "2018-11-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Toussaint"
  },
  {
    "date": "2018-11-11",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Armistice"
  },
  {
    "date": "2018-12-25",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Noël"
  },
  {
    "date": "2019-01-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Jour de l'an"
  },
  {
    "date": "2019-04-22",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pâques"
  },
  {
    "date": "2019-05-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête du travail"
  },
  {
    "date": "2019-05-08",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Victoire des alliés"
  },
  {
    "date": "2019-05-30",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Ascension"
  },
  {
    "date": "2019-06-10",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pentecôte"
  },
  {
    "date": "2019-07-14",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête Nationale"
  },
  {
    "date": "2019-08-15",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Assomption"
  },
  {
    "date": "2019-11-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Toussaint"
  },
  {
    "date": "2019-11-11",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Armistice"
  },
  {
    "date": "2019-12-25",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Noël"
  },
  {
    "date": "2020-01-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Jour de l'an"
  },
  {
    "date": "2020-04-13",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pâques"
  },
  {
    "date": "2020-05-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête du travail"
  },
  {
    "date": "2020-05-08",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Victoire des alliés"
  },
  {
    "date": "2020-05-21",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Ascension"
  },
  {
    "date": "2020-06-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pentecôte"
  },
  {
    "date": "2020-07-14",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête Nationale"
  },
  {
    "date": "2020-08-15",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Assomption"
  },
  {
    "date": "2020-11-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Toussaint"
  },
  {
    "date": "2020-11-11",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Armistice"
  },
  {
    "date": "2020-12-25",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Noël"
  },
  {
    "date": "2021-01-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Jour de l'an"
  },
  {
    "date": "2021-04-05",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pâques"
  },
  {
    "date": "2021-05-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête du travail"
  },
  {
    "date": "2021-05-08",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Victoire des alliés"
  },
  {
    "date": "2021-05-13",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Ascension"
  },
  {
    "date": "2021-05-24",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pentecôte"
  },
  {
    "date": "2021-07-14",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête Nationale"
  },
  {
    "date": "2021-08-15",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Assomption"
  },
  {
    "date": "2021-11-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Toussaint"
  },
  {
    "date": "2021-11-11",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Armistice"
  },
  {
    "date": "2021-12-25",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Noël"
  },
  {
    "date": "2022-01-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Jour de l'an"
  },
  {
    "date": "2022-04-18",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pâques"
  },
  {
    "date": "2022-05-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête du travail"
  },
  {
    "date": "2022-05-08",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Victoire des alliés"
  },
  {
    "date": "2022-05-26",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Ascension"
  },
  {
    "date": "2022-06-06",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pentecôte"
  },
  {
    "date": "2022-07-14",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête Nationale"
  },
  {
    "date": "2022-08-15",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Assomption"
  },
  {
    "date": "2022-11-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Toussaint"
  },
  {
    "date": "2022-11-11",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Armistice"
  },
  {
    "date": "2022-12-25",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Noël"
  },
  {
    "date": "2023-01-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Jour de l'an"
  },
  {
    "date": "2023-04-10",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pâques"
  },
  {
    "date": "2023-05-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête du travail"
  },
  {
    "date": "2023-05-08",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Victoire des alliés"
  },
  {
    "date": "2023-05-18",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Ascension"
  },
  {
    "date": "2023-05-29",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pentecôte"
  },
  {
    "date": "2023-07-14",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête Nationale"
  },
  {
    "date": "2023-08-15",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Assomption"
  },
  {
    "date": "2023-11-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Toussaint"
  },
  {
    "date": "2023-11-11",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Armistice"
  },
  {
    "date": "2023-12-25",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Noël"
  },
  {
    "date": "2024-01-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Jour de l'an"
  },
  {
    "date": "2024-04-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pâques"
  },
  {
    "date": "2024-05-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête du travail"
  },
  {
    "date": "2024-05-08",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Victoire des alliés"
  },
  {
    "date": "2024-05-09",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Ascension"
  },
  {
    "date": "2024-05-20",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pentecôte"
  },
  {
    "date": "2024-07-14",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête Nationale"
  },
  {
    "date": "2024-08-15",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Assomption"
  },
  {
    "date": "2024-11-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Toussaint"
  },
  {
    "date": "2024-11-11",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Armistice"
  },
  {
    "date": "2024-12-25",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Noël"
  },
  {
    "date": "2025-01-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Jour de l'an"
  },
  {
    "date": "2025-04-21",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pâques"
  },
  {
    "date": "2025-05-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête du travail"
  },
  {
    "date": "2025-05-08",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Victoire des alliés"
  },
  {
    "date": "2025-05-29",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Ascension"
  },
  {
    "date": "2025-06-09",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pentecôte"
  },
  {
    "date": "2025-07-14",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête Nationale"
  },
  {
    "date": "2025-08-15",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Assomption"
  },
  {
    "date": "2025-11-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Toussaint"
  },
  {
    "date": "2025-11-11",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Armistice"
  },
  {
    "date": "2025-12-25",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Noël"
  },
  {
    "date": "2026-01-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Jour de l'an"
  },
  {
    "date": "2026-04-06",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pâques"
  },
  {
    "date": "2026-05-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête du travail"
  },
  {
    "date": "2026-05-08",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Victoire des alliés"
  },
  {
    "date": "2026-05-14",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Ascension"
  },
  {
    "date": "2026-05-25",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pentecôte"
  },
  {
    "date": "2026-07-14",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête Nationale"
  },
  {
    "date": "2026-08-15",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Assomption"
  },
  {
    "date": "2026-11-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Toussaint"
  },
  {
    "date": "2026-11-11",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Armistice"
  },
  {
    "date": "2026-12-25",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Noël"
  },
  {
    "date": "2027-01-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Jour de l'an"
  },
  {
    "date": "2027-03-29",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pâques"
  },
  {
    "date": "2027-05-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête du travail"
  },
  {
    "date": "2027-05-06",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Ascension"
  },
  {
    "date": "2027-05-08",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Victoire des alliés"
  },
  {
    "date": "2027-05-17",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pentecôte"
  },
  {
    "date": "2027-07-14",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête Nationale"
  },
  {
    "date": "2027-08-15",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Assomption"
  },
  {
    "date": "2027-11-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Toussaint"
  },
  {
    "date": "2027-11-11",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Armistice"
  },
  {
    "date": "2027-12-25",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Noël"
  },
  {
    "date": "2028-01-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Jour de l'an"
  },
  {
    "date": "2028-04-17",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pâques"
  },
  {
    "date": "2028-05-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête du travail"
  },
  {
    "date": "2028-05-08",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Victoire des alliés"
  },
  {
    "date": "2028-05-25",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Ascension"
  },
  {
    "date": "2028-06-05",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pentecôte"
  },
  {
    "date": "2028-07-14",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête Nationale"
  },
  {
    "date": "2028-08-15",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Assomption"
  },
  {
    "date": "2028-11-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Toussaint"
  },
  {
    "date": "2028-11-11",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Armistice"
  },
  {
    "date": "2028-12-25",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Noël"
  },
  {
    "date": "2029-01-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Jour de l'an"
  },
  {
    "date": "2029-04-02",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pâques"
  },
  {
    "date": "2029-05-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête du travail"
  },
  {
    "date": "2029-05-08",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Victoire des alliés"
  },
  {
    "date": "2029-05-10",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Ascension"
  },
  {
    "date": "2029-05-21",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pentecôte"
  },
  {
    "date": "2029-07-14",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête Nationale"
  },
  {
    "date": "2029-08-15",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Assomption"
  },
  {
    "date": "2029-11-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Toussaint"
  },
  {
    "date": "2029-11-11",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Armistice"
  },
  {
    "date": "2029-12-25",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Noël"
  },
  {
    "date": "2030-01-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Jour de l'an"
  },
  {
    "date": "2030-04-22",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pâques"
  },
  {
    "date": "2030-05-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête du travail"
  },
  {
    "date": "2030-05-08",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Victoire des alliés"
  },
  {
    "date": "2030-05-30",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Ascension"
  },
  {
    "date": "2030-06-10",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pentecôte"
  },
  {
    "date": "2030-07-14",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête Nationale"
  },
  {
    "date": "2030-08-15",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Assomption"
  },
  {
    "date": "2030-11-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Toussaint"
  },
  {
    "date": "2030-11-11",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Armistice"
  },
  {
    "date": "2030-12-25",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Noël"
  },
  {
    "date": "2031-01-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Jour de l'an"
  },
  {
    "date": "2031-04-14",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pâques"
  },
  {
    "date": "2031-05-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête du travail"
  },
  {
    "date": "2031-05-08",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Victoire des alliés"
  },
  {
    "date": "2031-05-22",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Ascension"
  },
  {
    "date": "2031-06-02",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pentecôte"
  },
  {
    "date": "2031-07-14",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête Nationale"
  },
  {
    "date": "2031-08-15",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Assomption"
  },
  {
    "date": "2031-11-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Toussaint"
  },
  {
    "date": "2031-11-11",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Armistice"
  },
  {
    "date": "2031-12-25",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Noël"
  },
  {
    "date": "2032-01-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Jour de l'an"
  },
  {
    "date": "2032-03-29",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pâques"
  },
  {
    "date": "2032-05-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête du travail"
  },
  {
    "date": "2032-05-06",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Ascension"
  },
  {
    "date": "2032-05-08",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Victoire des alliés"
  },
  {
    "date": "2032-05-17",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pentecôte"
  },
  {
    "date": "2032-07-14",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête Nationale"
  },
  {
    "date": "2032-08-15",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Assomption"
  },
  {
    "date": "2032-11-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Toussaint"
  },
  {
    "date": "2032-11-11",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Armistice"
  },
  {
    "date": "2032-12-25",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Noël"
  },
  {
    "date": "2033-01-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Jour de l'an"
  },
  {
    "date": "2033-04-18",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pâques"
  },
  {
    "date": "2033-05-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête du travail"
  },
  {
    "date": "2033-05-08",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Victoire des alliés"
  },
  {
    "date": "2033-05-26",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Ascension"
  },
  {
    "date": "2033-06-06",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pentecôte"
  },
  {
    "date": "2033-07-14",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête Nationale"
  },
  {
    "date": "2033-08-15",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Assomption"
  },
  {
    "date": "2033-11-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Toussaint"
  },
  {
    "date": "2033-11-11",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Armistice"
  },
  {
    "date": "2033-12-25",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Noël"
  },
  {
    "date": "2034-01-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Jour de l'an"
  },
  {
    "date": "2034-04-10",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pâques"
  },
  {
    "date": "2034-05-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête du travail"
  },
  {
    "date": "2034-05-08",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Victoire des alliés"
  },
  {
    "date": "2034-05-18",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Ascension"
  },
  {
    "date": "2034-05-29",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pentecôte"
  },
  {
    "date": "2034-07-14",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête Nationale"
  },
  {
    "date": "2034-08-15",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Assomption"
  },
  {
    "date": "2034-11-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Toussaint"
  },
  {
    "date": "2034-11-11",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Armistice"
  },
  {
    "date": "2034-12-25",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Noël"
  },
  {
    "date": "2035-01-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Jour de l'an"
  },
  {
    "date": "2035-03-26",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pâques"
  },
  {
    "date": "2035-05-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête du travail"
  },
  {
    "date": "2035-05-03",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Ascension"
  },
  {
    "date": "2035-05-08",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Victoire des alliés"
  },
  {
    "date": "2035-05-14",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pentecôte"
  },
  {
    "date": "2035-07-14",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête Nationale"
  },
  {
    "date": "2035-08-15",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Assomption"
  },
  {
    "date": "2035-11-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Toussaint"
  },
  {
    "date": "2035-11-11",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Armistice"
  },
  {
    "date": "2035-12-25",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Noël"
  },
  {
    "date": "2036-01-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Jour de l'an"
  },
  {
    "date": "2036-04-14",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pâques"
  },
  {
    "date": "2036-05-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête du travail"
  },
  {
    "date": "2036-05-08",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Victoire des alliés"
  },
  {
    "date": "2036-05-22",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Ascension"
  },
  {
    "date": "2036-06-02",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pentecôte"
  },
  {
    "date": "2036-07-14",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête Nationale"
  },
  {
    "date": "2036-08-15",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Assomption"
  },
  {
    "date": "2036-11-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Toussaint"
  },
  {
    "date": "2036-11-11",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Armistice"
  },
  {
    "date": "2036-12-25",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Noël"
  },
  {
    "date": "2037-01-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Jour de l'an"
  },
  {
    "date": "2037-04-06",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pâques"
  },
  {
    "date": "2037-05-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête du travail"
  },
  {
    "date": "2037-05-08",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Victoire des alliés"
  },
  {
    "date": "2037-05-14",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Ascension"
  },
  {
    "date": "2037-05-25",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pentecôte"
  },
  {
    "date": "2037-07-14",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête Nationale"
  },
  {
    "date": "2037-08-15",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Assomption"
  },
  {
    "date": "2037-11-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Toussaint"
  },
  {
    "date": "2037-11-11",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Armistice"
  },
  {
    "date": "2037-12-25",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Noël"
  },
  {
    "date": "2038-01-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Jour de l'an"
  },
  {
    "date": "2038-04-26",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pâques"
  },
  {
    "date": "2038-05-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête du travail"
  },
  {
    "date": "2038-05-08",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Victoire des alliés"
  },
  {
    "date": "2038-06-03",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Ascension"
  },
  {
    "date": "2038-06-14",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pentecôte"
  },
  {
    "date": "2038-07-14",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête Nationale"
  },
  {
    "date": "2038-08-15",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Assomption"
  },
  {
    "date": "2038-11-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Toussaint"
  },
  {
    "date": "2038-11-11",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Armistice"
  },
  {
    "date": "2038-12-25",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Noël"
  },
  {
    "date": "2039-01-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Jour de l'an"
  },
  {
    "date": "2039-04-11",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pâques"
  },
  {
    "date": "2039-05-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête du travail"
  },
  {
    "date": "2039-05-08",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Victoire des alliés"
  },
  {
    "date": "2039-05-19",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Ascension"
  },
  {
    "date": "2039-05-30",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pentecôte"
  },
  {
    "date": "2039-07-14",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête Nationale"
  },
  {
    "date": "2039-08-15",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Assomption"
  },
  {
    "date": "2039-11-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Toussaint"
  },
  {
    "date": "2039-11-11",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Armistice"
  },
  {
    "date": "2039-12-25",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Noël"
  },
  {
    "date": "2040-01-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Jour de l'an"
  },
  {
    "date": "2040-04-02",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pâques"
  },
  {
    "date": "2040-05-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête du travail"
  },
  {
    "date": "2040-05-08",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Victoire des alliés"
  },
  {
    "date": "2040-05-10",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Ascension"
  },
  {
    "date": "2040-05-21",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pentecôte"
  },
  {
    "date": "2040-07-14",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête Nationale"
  },
  {
    "date": "2040-08-15",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Assomption"
  },
  {
    "date": "2040-11-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Toussaint"
  },
  {
    "date": "2040-11-11",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Armistice"
  },
  {
    "date": "2040-12-25",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Noël"
  },
  {
    "date": "2041-01-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Jour de l'an"
  },
  {
    "date": "2041-04-22",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pâques"
  },
  {
    "date": "2041-05-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête du travail"
  },
  {
    "date": "2041-05-08",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Victoire des alliés"
  },
  {
    "date": "2041-05-30",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Ascension"
  },
  {
    "date": "2041-06-10",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pentecôte"
  },
  {
    "date": "2041-07-14",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête Nationale"
  },
  {
    "date": "2041-08-15",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Assomption"
  },
  {
    "date": "2041-11-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Toussaint"
  },
  {
    "date": "2041-11-11",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Armistice"
  },
  {
    "date": "2041-12-25",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Noël"
  },
  {
    "date": "2042-01-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Jour de l'an"
  },
  {
    "date": "2042-04-07",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pâques"
  },
  {
    "date": "2042-05-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête du travail"
  },
  {
    "date": "2042-05-08",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Victoire des alliés"
  },
  {
    "date": "2042-05-15",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Ascension"
  },
  {
    "date": "2042-05-26",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pentecôte"
  },
  {
    "date": "2042-07-14",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête Nationale"
  },
  {
    "date": "2042-08-15",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Assomption"
  },
  {
    "date": "2042-11-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Toussaint"
  },
  {
    "date": "2042-11-11",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Armistice"
  },
  {
    "date": "2042-12-25",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Noël"
  },
  {
    "date": "2043-01-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Jour de l'an"
  },
  {
    "date": "2043-03-30",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pâques"
  },
  {
    "date": "2043-05-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête du travail"
  },
  {
    "date": "2043-05-07",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Ascension"
  },
  {
    "date": "2043-05-08",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Victoire des alliés"
  },
  {
    "date": "2043-05-18",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pentecôte"
  },
  {
    "date": "2043-07-14",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête Nationale"
  },
  {
    "date": "2043-08-15",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Assomption"
  },
  {
    "date": "2043-11-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Toussaint"
  },
  {
    "date": "2043-11-11",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Armistice"
  },
  {
    "date": "2043-12-25",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Noël"
  },
  {
    "date": "2044-01-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Jour de l'an"
  },
  {
    "date": "2044-04-18",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pâques"
  },
  {
    "date": "2044-05-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête du travail"
  },
  {
    "date": "2044-05-08",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Victoire des alliés"
  },
  {
    "date": "2044-05-26",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Ascension"
  },
  {
    "date": "2044-06-06",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pentecôte"
  },
  {
    "date": "2044-07-14",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête Nationale"
  },
  {
    "date": "2044-08-15",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Assomption"
  },
  {
    "date": "2044-11-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Toussaint"
  },
  {
    "date": "2044-11-11",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Armistice"
  },
  {
    "date": "2044-12-25",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Noël"
  },
  {
    "date": "2045-01-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Jour de l'an"
  },
  {
    "date": "2045-04-10",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pâques"
  },
  {
    "date": "2045-05-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête du travail"
  },
  {
    "date": "2045-05-08",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Victoire des alliés"
  },
  {
    "date": "2045-05-18",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Ascension"
  },
  {
    "date": "2045-05-29",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pentecôte"
  },
  {
    "date": "2045-07-14",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête Nationale"
  },
  {
    "date": "2045-08-15",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Assomption"
  },
  {
    "date": "2045-11-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Toussaint"
  },
  {
    "date": "2045-11-11",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Armistice"
  },
  {
    "date": "2045-12-25",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Noël"
  },
  {
    "date": "2046-01-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Jour de l'an"
  },
  {
    "date": "2046-03-26",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pâques"
  },
  {
    "date": "2046-05-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête du travail"
  },
  {
    "date": "2046-05-03",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Ascension"
  },
  {
    "date": "2046-05-08",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Victoire des alliés"
  },
  {
    "date": "2046-05-14",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pentecôte"
  },
  {
    "date": "2046-07-14",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête Nationale"
  },
  {
    "date": "2046-08-15",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Assomption"
  },
  {
    "date": "2046-11-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Toussaint"
  },
  {
    "date": "2046-11-11",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Armistice"
  },
  {
    "date": "2046-12-25",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Noël"
  },
  {
    "date": "2047-01-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Jour de l'an"
  },
  {
    "date": "2047-04-15",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pâques"
  },
  {
    "date": "2047-05-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête du travail"
  },
  {
    "date": "2047-05-08",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Victoire des alliés"
  },
  {
    "date": "2047-05-23",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Ascension"
  },
  {
    "date": "2047-06-03",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pentecôte"
  },
  {
    "date": "2047-07-14",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête Nationale"
  },
  {
    "date": "2047-08-15",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Assomption"
  },
  {
    "date": "2047-11-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Toussaint"
  },
  {
    "date": "2047-11-11",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Armistice"
  },
  {
    "date": "2047-12-25",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Noël"
  },
  {
    "date": "2048-01-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Jour de l'an"
  },
  {
    "date": "2048-04-06",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pâques"
  },
  {
    "date": "2048-05-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête du travail"
  },
  {
    "date": "2048-05-08",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Victoire des alliés"
  },
  {
    "date": "2048-05-14",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Ascension"
  },
  {
    "date": "2048-05-25",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pentecôte"
  },
  {
    "date": "2048-07-14",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête Nationale"
  },
  {
    "date": "2048-08-15",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Assomption"
  },
  {
    "date": "2048-11-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Toussaint"
  },
  {
    "date": "2048-11-11",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Armistice"
  },
  {
    "date": "2048-12-25",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Noël"
  },
  {
    "date": "2049-01-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Jour de l'an"
  },
  {
    "date": "2049-05-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête du travail"
  },
  {
    "date": "2049-05-02",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pâques"
  },
  {
    "date": "2049-05-08",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Victoire des alliés"
  },
  {
    "date": "2049-06-09",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Ascension"
  },
  {
    "date": "2049-06-20",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pentecôte"
  },
  {
    "date": "2049-07-14",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête Nationale"
  },
  {
    "date": "2049-08-15",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Assomption"
  },
  {
    "date": "2049-11-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Toussaint"
  },
  {
    "date": "2049-11-11",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Armistice"
  },
  {
    "date": "2049-12-25",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Noël"
  },
  {
    "date": "2050-01-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Jour de l'an"
  },
  {
    "date": "2050-04-11",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pâques"
  },
  {
    "date": "2050-05-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête du travail"
  },
  {
    "date": "2050-05-08",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Victoire des alliés"
  },
  {
    "date": "2050-05-19",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Ascension"
  },
  {
    "date": "2050-05-30",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Lundi de Pentecôte"
  },
  {
    "date": "2050-07-14",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Fête Nationale"
  },
  {
    "date": "2050-08-15",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Assomption"
  },
  {
    "date": "2050-11-01",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Toussaint"
  },
  {
    "date": "2050-11-11",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Armistice"
  },
  {
    "date": "2050-12-25",
    "est_jour_ferie": "True",
    "nom_jour_ferie": "Noël"
  }
]

// Returns true if the given "YYYY-MM-DD" date string is a French public holiday.
export const isJourFerie = dateStr => joursFeries.some(jourFerie => jourFerie.date === dateStr);

export default joursFeries;


// WEBPACK FOOTER //
// src/containers/activite/planning/Calendar.util.js